import { render } from "./AsignarTransportesPage.vue?vue&type=template&id=ecefad9c&scoped=true"
import script from "./AsignarTransportesPage.vue?vue&type=script&lang=js"
export * from "./AsignarTransportesPage.vue?vue&type=script&lang=js"

import "./AsignarTransportesPage.vue?vue&type=style&index=0&id=ecefad9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecefad9c"]])

export default __exports__